import React from "react";
import { Route, Redirect } from "react-router-dom";

import { isAuthenticated } from '../../servicos/autenticacao';

function RotaPrivada({ component: Component, ...rest }) {

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect push to={{ pathname: "/", state: { from: props.location }}} />
        )
      }
    />
  );
}

export default RotaPrivada;